import { BottomNav } from '@/components/layout/bottom-nav';
import { SidebarNav } from '@/components/layout/sidebar-nav';

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="bg-background">
      <SidebarNav />

      <main className="pb-20 md:ml-64 md:pb-0">
        <div>{children}</div>
      </main>

      <BottomNav />
    </div>
  );
}
